export default __webpack_public_path__ + "static/media/list_selected.8e0229ef.svg";